import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    _commodityDetailsId: Yup.number().required(requiredMessage).nullable(),
    commodityId: Yup.string().nullable(),
    vehicleIdType: Yup.string().nullable(),
    vehicleIdNumber: Yup.string().nullable(),
    vehicleTitleNumber: Yup.string().nullable(),
    vehicleTitleState: Yup.string().nullable(),
  })
}

export default makeValidationSchema
